import React from 'react';

/**
 * Header checkbox for selecting all rows
 */
const HeaderCheckbox = ({ table }) => {
  const isAllSelected = table.getIsAllRowsSelected();
  const isSomeSelected = table.getIsSomeRowsSelected();
  const isIndeterminate = isSomeSelected && !isAllSelected;

  const getClassName = () => {
    if (isAllSelected) return 'table-view__checkbox-custom table-view__checkbox-custom--checked';
    if (isIndeterminate) return 'table-view__checkbox-custom table-view__checkbox-custom--indeterminate';
    return 'table-view__checkbox-custom';
  };

  return (
    <label className="table-view__checkbox-wrapper">
      <input
        type="checkbox"
        className="table-view__checkbox"
        checked={isAllSelected}
        ref={(el) => {
          if (el) el.indeterminate = isIndeterminate;
        }}
        onChange={table.getToggleAllRowsSelectedHandler()}
      />
      <span className={getClassName()}>
        {isAllSelected && <span className="table-view__checkbox-tick">✓</span>}
        {isIndeterminate && <span className="table-view__checkbox-tick">−</span>}
      </span>
    </label>
  );
};

export default HeaderCheckbox;

